import React, { useState, useEffect } from 'react';
import { setItem } from '../reducers/ItemSlice'
import { Row, Col, Container, Dropdown, ButtonGroup, DropdownButton, DropdownMenu, Form } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { toggleMenuOpen } from '../reducers/MenuOpenSlice'
import uuid from "react-uuid";
import { setParam } from '../reducers/ParamSlice'
import { setTooltip2 } from '../reducers/Tooltip2Slice'

const MultiSelectDropdown = () => {
    const item = useSelector((state) => state.item.value)
    const data = useSelector((state) => state.data.value)
    const param = useSelector((state) => state.param.value)
    const draw = useSelector((state) => state.draw.value)
    const menuOpen = useSelector((state) => state.menuOpen.value)
    const dispatch = useDispatch()
    const [hotels, setHotels] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isAll, setIsAll] = useState("נקה בחירה");
    const [selectedLabels, setSelectedLabels] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [options, setOptions] = useState(null)
    const [ready, setReady] = useState(false)

    useEffect(() => {

        if (Object.keys(data[0]).length > 0) {

            const hotels = data[0][param].map(d => d.name).sort()

            const allSelected = item.names.length == hotels.length;
          
            setHotels(hotels)
            setSelectedOptions(allSelected ? [0, ...hotels.map((d, i) => {
                if (item.names.includes(d)) {
                    return i + 1
                }
            }
            )] : hotels.map((d, i) => {
                if (item.names.includes(d)) {
                    return i + 1
                }
            } ))
            setIsAll(allSelected ? "נקה בחירה" : "בחר הכל")
            setSelectedLabels([allSelected ? "נקה בחירה" : "בחר הכל", ...hotels])
            setOptions([{ id: 0, label: allSelected ? "נקה בחירה" : "בחר הכל" },
            ...hotels.map((d, i) => (

                { id: i + 1, label: d }

            ))])
        }
        setReady(true)


    }, [data, param, item.names])



    const handleParamDropdown = value => {
        dispatch(setParam(value))
        const labels = data[0][value].map(d => d.name).sort()
        const tmpData =  data[0][value].filter(d => labels.includes(d.name))
        const idxs = tmpData.map(d=>d.idx)
        dispatch(setItem({
            type: "hotel",
            names: [],
            data: [],
            idxs:[]
        }))
        dispatch(setTooltip2({
            show: false,
            x: 0,
            y: 0,
            data: {},

        }))

    };






    const toggleDropdown = () => {
        dispatch(toggleMenuOpen(!menuOpen))
    };

    const handleMouseOut = (e) => {

        dispatch(toggleMenuOpen(false))
    };

    const handleOptionChange = (event) => {


        const optionId = parseInt(event.target.value);
        const isChecked = event.target.checked;
        let ids = []

        if (isChecked & optionId == 0) {
            setIsAll("נקה בחירה")
            setOptions([{ id: 0, label: "נקה בחירה" },
            ...hotels.map((d, i) => (

                { id: i + 1, label: d }

            ))])

            ids = [0, ...hotels.map((d, i) => i + 1)]

        }
        else if (!isChecked & optionId == 0) {
            setIsAll("בחר הכל")
            setOptions([{ id: 0, label: "בחר הכל" },
            ...hotels.map((d, i) => (

                { id: i + 1, label: d }

            ))])
            ids = []

        }
        else if (isChecked) {
            ids = [...selectedOptions, optionId]
        }
        else {
            ids = selectedOptions.filter((id) => id !== optionId)

        }
        setSelectedOptions(ids)
        const labels = ids.filter(d=>d>0).map((i) => {
            if (i > 0) {
                return hotels[i - 1]
            }
        })
       
        setSelectedLabels(labels)
        const tmpData =  data[0][param].filter(d => labels.includes(d.name))
        const idxs = tmpData.map(d=>d.idx)

        dispatch(setItem({
            type: "hotel",
            names: labels,
            data: tmpData,
            idxs:idxs
        }))

    };

    return (
        <>
            {(Array.isArray(options)) ? (
                <>


                    <Dropdown as={ButtonGroup} show={menuOpen}>
                        <Dropdown.Toggle
                            onClick={toggleDropdown}


                            className={` customdropdown`}
                            id="multiSelectDropdown"
                        > בחר מלון

                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            style={{ overflowY: 'scroll', maxHeight: "25vh" }}
                            aria-labelledby="multiSelectDropdown"
                            onMouseLeave={handleMouseOut}
                        >


                            {options.map((option) => (
                                <Dropdown.Item key={uuid()} className={`customdropdown `}>
                                    <Form.Check
                                        // className={` ${isOpen ? 'show' : ''}`}
                                        key={option.id}
                                        type="checkbox"
                                        id={`option_${option.id}`}
                                        label={option.label}
                                        checked={selectedOptions.includes(option.id)}
                                        onChange={handleOptionChange}
                                        value={option.id}
                                    />

                                </Dropdown.Item>
                            ))}

                        </Dropdown.Menu>

                    </Dropdown>{"    "}

                    <DropdownButton onSelect={handleParamDropdown} as={ButtonGroup} title="בחר עיר" id="bg-nested-dropdown"
                        className={"customdropdown"}>
                        {Object.keys(data[0]).map((d) => (
                            <Dropdown.Item key={uuid()} eventKey={d} className={"customdropdown"}
                            >
                                {d}
                            </Dropdown.Item>
                        ))}
                    </DropdownButton>


                </>
            ) : (<></>)}


        </>
    );
};

export default MultiSelectDropdown;